import { Box, Typography } from "@mui/material";
import EmptyJourneysIcon from "../../icons/EmptyJourneysIcon";
import styles from "./styles.module.scss"

const EmptyJourney = ({ children, title = "Journey is Empty" }) => {
    return (
        <Box className={styles.journeysEmpty}>
            <Box className={styles.journeysEmptyIconContainer}>
                <EmptyJourneysIcon />
            </Box>
            <Typography className={styles.journeysEmptyLabel}>
                {title}
            </Typography>
            {children && children}
        </Box>
    );
}

export default EmptyJourney;
